export default __webpack_public_path__ + "static/media/bull3.97aa5238.png";